var _defs, _rect, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorHeader1024Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1200,
    height: 920,
    viewBox: "0 0 1200 920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#fff;opacity:0.24;mix-blend-mode:overlay;}.b,.c{isolation:isolate;}.c{fill:none;stroke:#fff;stroke-width:2px;opacity:0.478;mix-blend-mode:soft-light;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00cacd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0080a2"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1200,
    height: 920
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(198.746 94.804)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 7.047,
    cy: 5.059,
    rx: 7.047,
    ry: 5.059,
    transform: "translate(675.47 15.952)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(69.613 11.633)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 4.688,
    cy: 2.249,
    rx: 4.688,
    ry: 2.249,
    transform: "translate(857.113 3.141)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 2.93,
    cy: 1.405,
    rx: 2.93,
    ry: 1.405,
    transform: "translate(475.082)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 5.547,
    cy: 5.059,
    rx: 5.547,
    ry: 5.059,
    transform: "translate(564.856 713.549)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 4.688,
    cy: 2.249,
    rx: 4.688,
    ry: 2.249,
    transform: "translate(16 721.231)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 4.688,
    cy: 2.249,
    rx: 4.688,
    ry: 2.249,
    transform: "translate(848.5 627.739)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 2.93,
    cy: 1.405,
    rx: 2.93,
    ry: 1.405,
    transform: "translate(405.469 723.597)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.31 101.728)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3.634,1.8l15.9-2.359c.878-.13,1.492.216,1.371.773L18.711,10.3a2.177,2.177,0,0,1-1.81,1.244L1,13.906c-.878.13-1.492-.216-1.371-.773l2.2-10.085A2.177,2.177,0,0,1,3.634,1.8Z",
    transform: "translate(517.523 3.471) rotate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.027.059l10.212,1.25c1.253.153,2.394.863,2.547,1.585l1.25,5.883c.153.722-.738,1.183-1.992,1.03L3.832,8.556C2.579,8.4,1.439,7.693,1.285,6.971L.036,1.088C-.118.366.774-.095,2.027.059Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 16.606)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(413.172 843.84)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3.022,1.887,16.507-.555c.745-.135,1.265.223,1.162.8L15.807,10.683a1.914,1.914,0,0,1-1.535,1.288L.787,14.412c-.745.135-1.265-.223-1.162-.8L1.488,3.175A1.914,1.914,0,0,1,3.022,1.887Z",
    transform: "translate(475.691 -32.091) rotate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.039.053l5.187,1A1.659,1.659,0,0,1,7.519,2.317l.635,4.7c.078.577-.375.945-1.012.822l-5.187-1A1.659,1.659,0,0,1,.662,5.573L.027.875C-.051.3.4-.07,1.039.053Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 1, -25.394)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorHeader1024Px);
export default __webpack_public_path__ + "static/media/errorHeader_1024px.2994742efbced21c3f81fd69bb21d2e8.svg";
export { ForwardRef as ReactComponent };